module.exports = __webpack_public_path__ + "static/media/serpent-09.c2ffc559.png";